export class ActivationCodeModel {

  /**
   * Constructor
   *
   * @param {string} code
   * @param {boolean} valid
   */
  public constructor(
    public code: string = null,
    public valid: boolean = false,
  ) { }
}
